import { Flex, Spinner, Text } from '@chakra-ui/react';

interface Props {
  size?: 'sm' | 'md' | 'lg';
  label: string;
}

export function SpinnerWithLabel({ label, size }: Props) {
  return (
    <Flex
      w="fit-content"
      gap={2}
      align="center"
      justify="center"
      bg="texas.bg.900"
      p={2}
      borderRadius="md"
      _light={{ bg: 'gray.50' }}
    >
      <Spinner size={size} />
      <Text>{label}</Text>
    </Flex>
  );
}
